import React from 'react'
import dp from "../assets/hero.png"
import {Link} from "react-scroll"

const hero = () => {
    return (
        <header className="hero" id="hero">
            <div className="section-center hero-center">
                <article className="hero-info">
                    <div>
                        <div className="underline"></div>
                        <h1>i'm shreyank singhal</h1>
                        <h4>Web developer and enthusiast coder</h4>
            <Link to="contact" smooth={true} duration={1000} offset={-80} className="btn">contact me</Link>
            <a href="https://docs.google.com/document/d/1ysAzGCV3YS-g0iQs8XclN7xwVce9HS6b1UoYPGmUeeA/edit?usp=sharing" target="__blank" className="btn resume-btn">Resume</a>
                    </div>
                </article>
                <div className="img-box">
                    <img src={dp} alt="" className="hero-img"/>
                </div>
            </div>
        </header>
    )
}

export default hero
